export const INSTANCE_NAMES = {
    LEGACY_CARD_COLLECTION: 'LEGACY_CARD_COLLECTION',
    LEGACY_PRODUCT_COLLECTION: 'LEGACY_PRODUCT_COLLECTION',
    REMAINING_LIMITS_COLLECTION: 'REMAINING_LIMITS_COLLECTION',
    SECURITIES_ACCOUNT_MODEL: 'SECURITIES_ACCOUNT_MODEL',
    SIZE_HELPER: 'SIZE_HELPER',
    TRANSACTION_CHECK_HELPER: 'TRANSACTION_CHECK_HELPER',
    USER_CONFIGURATION: 'USER_CONFIGURATION',
    USER_CONFIGURATION_COLLECTION: 'USER_CONFIGURATION_COLLECTION',
} as const;

type SICKey = keyof typeof INSTANCE_NAMES;
type SICValue = (typeof INSTANCE_NAMES)[SICKey];
type SingleInstanceCacheKey = SICKey | SICValue;

const cache = {} as Record<SingleInstanceCacheKey, any>;

export function getInstance<T>(name: SingleInstanceCacheKey, defaultInstance?: T): T {
    if (cache[name] === undefined) {
        cache[name] = defaultInstance;
    }

    return cache[name];
}

export function clearInstances(): void {
    Object.keys(cache).forEach((instance) => {
        delete cache[instance as SingleInstanceCacheKey];
    });
}

export function setInstance<T>(name: SingleInstanceCacheKey, instance: T): void {
    cache[name] = instance;
}
